
export function SiteNavigationComponent() {
    for (let siteNavigationComponent of document.querySelectorAll('.site-navigation')) {
        let header = siteNavigationComponent.closest('.site-header');
        let menuToggle = siteNavigationComponent.querySelector('.toggle-menu');
        let dropdown = siteNavigationComponent.querySelector('.dropdown');
        menuToggle.addEventListener('click', function() {
            if (siteNavigationComponent.classList.contains('expanded')) {
                siteNavigationComponent.classList.remove('expanded');
                siteNavigationComponent.classList.add('collapsing');
                let animation = dropdown.animate([
                    { transform: 'translateX(0)' },
                    { transform: 'translateX(100%)' },
                ], { duration: 350, easing: 'ease' });
                animation.addEventListener('finish', function() {
                    siteNavigationComponent.classList.remove('collapsing');
                    siteNavigationComponent.classList.add('collapsed');
                    header.classList.remove('expanded');
                });
            }
            else {
                siteNavigationComponent.classList.remove('collapsed');
                siteNavigationComponent.classList.add('expanded');
                header.classList.add('expanded');
                dropdown.animate([
                    { transform: 'translateX(100%)' },
                    { transform: 'translateX(0)' },
                ], { duration: 350, easing: 'ease' });
            }
        });
        for (let menuItem of siteNavigationComponent.querySelectorAll('.menu-item')) {
            let toggle = menuItem.querySelector('button');
            if (toggle === null) {
                continue;
            }
            let submenu = menuItem.querySelector('.fly-out');
            toggle.addEventListener('click', function() {
                if (menuItem.classList.contains('expanded')) {
                    let { height } = submenu.getBoundingClientRect();
                    menuItem.classList.remove('expanded');
                    menuItem.classList.add('collapsing');
                    menuItem.setAttribute('aria-expanded', 'false');
                    let animation = submenu.animate([
                        { maxHeight: `${height}px`, overflowY: 'hidden', marginBottom: '0' },
                        { maxHeight: `0`, overflowY: 'hidden', marginBottom: '-4px' },
                    ], { duration: 350, easing: 'ease' });
                    animation.addEventListener('finish', function() {
                        menuItem.classList.remove('collapsing');
                        menuItem.classList.add('collapsed');
                    });
                }
                else {
                    menuItem.classList.remove('collapsed');
                    menuItem.classList.add('expanded');
                    menuItem.setAttribute('aria-expanded', 'true');
                    let { height } = submenu.getBoundingClientRect();
                    submenu.animate([
                        { maxHeight: `0`, overflowY: 'hidden' },
                        { maxHeight: `${height}px`, overflowY: 'hidden' },
                    ], { duration: 350, easing: 'ease' });
                }
            });
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', SiteNavigationComponent);
}
else {
    SiteNavigationComponent();
}
